import React, { FC } from "react";
import { Chip, Divider, GridOwnProps, Stack, Typography } from "@mui/material";

import NorthEastIcon from "@mui/icons-material/NorthEast";
import SouthEastIcon from "@mui/icons-material/SouthEast";
import KPICard from "../../components/KpiCards/KpiCard";
import getIcon, { IconNames } from "./IconMappings";
import { useAppTheme } from "../../utils/theme";

type Props = {
	title: string;
	icon: React.ReactNode;
	content: React.ReactNode;
	footer: React.ReactNode;
	boxProps?: GridOwnProps;
};

const AverageComponentBase: FC<Props> = (props) => {
	return (
		<KPICard boxProps={{ height: 200 }} {...props.boxProps}>
			<Stack
				direction="column"
				justifyContent={"space-between"}
				height={"100%"}
			>
				<Stack direction="row" spacing={2} justifyContent={"space-between"}>
					<Typography variant="subtitle1" color="textSecondary">
						{props.title}
					</Typography>
					{props.icon}
				</Stack>
				{props.content}
				<Divider sx={{ borderColor: "#E7F3FF", borderBottomWidth: "2px" }} />
				{props.footer}
			</Stack>
		</KPICard>
	);
};

type AverageComponentProps = {
	title: string;
	icon: IconNames;
	content: React.ReactNode;
	increased: boolean;
	footerLabel: string;
	footerDescription: string;
	boxProps?: GridOwnProps;
};

const AverageComponent: FC<AverageComponentProps> = (props) => {
	const theme = useAppTheme();
	return (
		<AverageComponentBase
			boxProps={props.boxProps}
			title={props.title}
			icon={getIcon(props.icon, theme.palette.secondary.light)}
			content={props.content}
			footer={
				<Stack direction="row" spacing={1} alignItems={"center"}>
					<Chip
						icon={
							props.increased ? (
								<NorthEastIcon sx={{ maxHeight: "16px", maxWidth: "16px" }} />
							) : (
								<SouthEastIcon sx={{ maxHeight: "16px", maxWidth: "16px" }} />
							)
						}
						label={props.footerLabel}
					/>
					<Typography variant="body2" color="textSecondary">
						{props.footerDescription}
					</Typography>
				</Stack>
			}
		/>
	);
};

export default AverageComponent;
